import 'bootstrap/dist/css/bootstrap.css';
import './css/main.css';

import React from 'react';
import { render } from "react-dom";
import { Router, Route, hashHistory } from "react-router";
import HlsJS from "hls.js";

import IndexScreen from "./js/IndexScreen";
import Level1App from "./js/Level1App";
import Level2App from "./js/Level2App";
import { listLoggedInServers } from "./js/include/Server";
import GamesApp from "./js/GamesApp";
import Analytics from "./js/include/Analytics";

// Disable accidental right click (relevant for touch)
document.oncontextmenu = () => false;

// Give user a warning if using incorrect browser
if (!window.fetch || !HlsJS.isSupported()) {
    alert("Browser does not support necessary features. Please use an updated version of Google Chrome");
}

Analytics.init();

function renderApp () {
    render((
        <Router history={hashHistory}>
            <Route path="/" component={IndexScreen} />
            <Route onEnter={checkAuthentication}>
                <Route path="/level1" component={Level1App} />
                <Route path="/level2" component={Level2App} />
                <Route path="/games" component={GamesApp} />
            </Route>
        </Router>
    ), document.getElementById("root"));
}

function checkAuthentication (nextState, replace) {
    if (listLoggedInServers().length === 0) {
        replace({pathname: '/'});
    }
}

function verifyLoginSessionsAndStartApp () {
    let servers = listLoggedInServers();
    if (servers.length === 0) {
        console.log("No access token set - user not logged in");
        renderApp();
        return;
    }

    let requestDoneCounter = 0;
    let onRequestHandled = () => {
        if (++requestDoneCounter === servers.length) {
            renderApp();
        }
    };

    servers.forEach((server) => {
        console.log("Access token set for " + server.name + "- validating...");

        server.get("/user/me", (user) => {

            if (user.access_level !== "admin" && user.access_level !== "super") {
                console.error("Logged in user is not admin");
                server.logOut();
            }
            console.log("Successfully validated login session for " + server.name);
            onRequestHandled();
        }, (error) => {

            console.error("Failed to verify login session", error);
            server.logOut();

            onRequestHandled();
        });
    });
}

verifyLoginSessionsAndStartApp();



// WEBPACK FOOTER //
// ./src/index.js